const TabsViewKey = Symbol("TabsView");
export {
  TabsViewKey as T
};
//# sourceMappingURL=types.js.map
